import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
// * Core UI Components
import {
  CContainer,
  CCard,
  CCardBody,
  CRow,
  CCol,
  CTable,
  CTableHead,
  CTableHeaderCell,
  CTableBody,
  CTableRow,
  CTableDataCell,
  CFormInput,
  CButton,
  CModalBody,
  CFormCheck,
  CFormSelect,
  CModalHeader,
  CModalTitle,
  CModal,
  CModalFooter
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import {
  cilPlus,
  cilPencil,
  cilX,
  cilSearch,
  cilExternalLink,
} from "@coreui/icons";
import style from "./index.module.css"
import { useState } from "react";
import {
  fetchTableData, fetchRecordsForPage, saveBatch, getAllBatches
  , fetchBatchData, addingCandidates, deleteCandidates
} from "./manageCandidatesApi";

import { getCandidatesByBatchId } from "../ViewCandidates/viewCandidatesApi";
import { CreateBatch } from "src/Router/Routes";
import { useLoading } from "src/contexts/Loading/LoadingState";
import { CheckboxCandidateContext } from "src/contexts/CheckboxCandidate/CheckboxState";
import { BASE_URL } from "src/config/config";

import Pagination from "../../../components/Paginations/paginations"
import { toast } from 'react-toastify'
import PreviusButton from "src/components/PreviousButton";

const index = () => {
  const [tableData, setTableData] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [selectedRows, setSelectedRows] = useState({});
  const [batchData, setBatchData] = useState({})
  const [allBatches, setAllBatches] = useState([]);
  const { loading, setLoading } = useLoading();
  const { CheckboxCandidate, setCheckboxCandidate } = useContext(CheckboxCandidateContext);
  const [batchDropDown, setBatchDropdown] = useState('');
  const [allCandidates, setAllCandidates] = useState([])
  const [deletedCandidate, setDeletedCandidate] = useState([])
  const [flag, setFlag] = useState(false)
  let batchCandidates = [];
  let navigate = useNavigate()

  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    sort: 1,
  });

  console.log(CheckboxCandidate, "000000000000000000000000000000000000000")

  let pageNumber;

  const setPage = (data) => {
    setCurrentPage(data.currentPage)
  };


  async function handleAddLimit(e) {
    // console.log("number", e.target.value)
    if (e.target.value == "All") {
      setParams({ ...params, limit: Number(totalRecords) })
    } else {
      setParams({ ...params, limit: Number(e.target.value) })
    }
  }



  const handleRowSelect = async (id) => {
    if (CheckboxCandidate[id]) {

      if (CheckboxCandidate[id] === "Database") {
        setDeletedCandidate(prevState => [...prevState, id]);
      }
      // If the ID exists in state, remove it
      setCheckboxCandidate(prevState => {
        const newState = { ...prevState };
        delete newState[id];
        return newState;
      });
    } else {
      // If the ID doesn't exist in state, add it
      setCheckboxCandidate(prevState => ({
        ...prevState,
        [id]: "Available"
      }));
    }

    // Log the updated object
    // console.log(CheckboxCandidate);



    // setFlag(!flag)

    // await removeCandidates(id)
    setBatchData(prevBatchData => {
      const currentPageData = prevBatchData[currentPage] || []; // Get the current page data or initialize an empty array if it doesn't exist

      if (currentPageData.includes(id)) {
        // If the id is already selected, remove it
        return {
          ...prevBatchData,
          [currentPage]: currentPageData.filter(rowId => rowId !== id)
        };
      } else {
        // If the id is not selected, add it
        return {
          ...prevBatchData,
          [currentPage]: [...currentPageData, id]
        };
      }
    });
  };


  useEffect(() => {
    (async function () {
      try {
        let res = await fetchTableData(currentPage, Math.floor(params.limit));
        setTableData(res.data);
        // console.log(res.data, "-------------************")
        setTotalPages(res.totalPages);
        // setCurrentPage(res.currentPage)
        setParams({ ...params, limit: res.limit, page: currentPage })
        setTotalRecords(res.totalRecords)
      } catch (error) {
        console.error('Error occurred:', error);
      }
    })();

    fetchAllCandidates(batchDropDown)

  }, [currentPage, params.limit])

  async function fetchAllBatches() {
    try {
      let res = await getAllBatches(currentPage, params.limit);
      // setAllBatches(prevState => [...prevState, ...res.data]); 
      console.log(res.data, "++++++++++++++++++++");
    } catch (error) {
      console.error('Error occurred:', error);
    }
  }




  async function fetchAllCandidates(batchId) {
    console.log(batchId, "batchID")

    try {
      const allData = await getCandidatesByBatchId(currentPage, params.limit, batchId);


      console.log(allData, "-----------alldATA-----------------");

      if (allData.data && allData.data.length > 0) {
        const candidates = allData.data.filter(candidate => candidate.batch_id == batchId);
        console.log(candidates, "candidates+++++++++++++++++++++")
        if (candidates.length > 0) {
          const candidateIds = candidates.map(candidate => candidate.id);

          // Update checkboxCandidate state with candidates
          setCheckboxCandidate(prevState => ({
            ...prevState,
            ...candidateIds.reduce((acc, curr) => ({ ...acc, [curr]: "Database" }), {})
          }));
          // setCheckboxCandidate({})
          // setAllCandidates(candidates);
          // console.log(candidates.length, "Total candidates")
          // console.log(candidates, "000000000000000000000000000000");
        } else {
          toast.error("No candidates found for the specified batch", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          console.log("No candidates found for the specified batch_id");
        }
      }
    } catch (error) {
      console.error('Error occurred:', error);
    }
  }

  useEffect(() => {
    fetchAllBatches();
  }, [])


  fetchRecordsForPage(pageNumber, params.limit)

  const handleSelectAll = async (event) => {
    console.log(currentPage, "---------------current page");
    const isChecked = event.target.checked;
    let pageIds; // Define pageIds variable here

    if (isChecked) {
      console.log("cheked")
      fetchRecordsForPage(currentPage, params.limit)
        .then(result => {
          const data = result.data;
          pageIds = data.map(item => item.id); // Assign value to pageIds
          console.log(pageIds, "PageIDS");

          setCheckboxCandidate(prevState => ({
            ...prevState,
            ...pageIds.reduce((acc, curr) => ({ ...acc, [curr]: "Available" }), {})
          }));

          setSelectedRows(prevState => ({
            ...prevState,
            [currentPage]: "Available"
          }));
        })
        .catch(error => {
          console.error('Error fetching records for page', ':', error);
        });
    } else {
      // Here you can access pageIds
      // console.log("Un --------------checked")

      const res = await fetchTableData(currentPage, Math.floor(params.limit));
      const newData = res.data;
      console.log(newData, "newData-------------")
      // Remove all keys from checkboxCandidate state
      setCheckboxCandidate(prevState => {
        const newState = { ...prevState };
        newData.forEach(item => {
          if (newState[item.id]) {
            delete newState[item.id];
          }
        });
        return newState;
      });

      // Remove current page key from selectedRows state
      setSelectedRows(prevState => {
        const newState = { ...prevState };
        delete newState[currentPage];
        return newState;
      });
    }


  };


  const handleBatchName = (event) => {
    if (event.target.value == "") {
      setBatchDropdown("")
      setAllCandidates([])
    } else {
      setBatchDropdown(event.target.value)
      console.log(event.target.value, "--------------------------")
      fetchAllCandidates(event.target.value);
    }
  }


  const addToBatchBtn = async () => {
    if (batchCandidates.length == 0) {
      toast.error("Select Candidates from Table", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } else if (batchDropDown == '') {
      toast.error("Select Batch first", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
    else {
      if (deletedCandidate.length > 0) {
        await deleteCandidates(batchDropDown, deletedCandidate)
      }
      await addingCandidates(batchDropDown, batchCandidates)
      batchCandidates = []
      setBatchDropdown('')
      setCheckboxCandidate({})
      navigate("/manageBatch")
      //  console.log(batchCandidates, batchDropDown, "-----------------------")
    }
  }


  async function fetchBatch() {
    try {
      let res = await fetchBatchData();
      // console.log(res,"------------------------")
      setAllBatches(res);
    } catch (error) {
      console.error('Error occurred:', error);
    }
  }

  useEffect(() => {
    fetchBatch()
  }, [])


  batchCandidates = Object.keys(CheckboxCandidate)



  console.log(selectedRows, "selectedRow00000000000000000000000000000000000000000000000")
  // console.log(batchData, "batchDtaa+++++++++++++++++++++++++++++++++++++++++++++")
  // console.log(allBatches, "all batches +++++++++++++++++++++++++++++++++++")
  // console.log(updatedBatchCandidates, "updatedBatches===================")
  // console.log(batchCandidates, "batch candidates+++++++++++++++++++++++++")
  // console.log(deletedCandidate, "DeletedCandiate")
  // console.log(allCandidates, "all candidates @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@2")


  return (
    <>
      <CContainer fluid>
        <CCard>
          <CCardBody className={`${style.wrapper} d-flex flex-column`}>
            <CRow className="row g-3">
              <CRow>
                <CCol style={{ paddingTop: "20px" }}>
                  <div style={{display:"flex"}}>
                    <PreviusButton />
                    <h4 style={{marginLeft: "10px"}}>Manage Candidates</h4>
                  </div>
                </CCol>
              </CRow>
              <CRow className="row g-3 align-items-center">
                <CCol xs="auto">
                  <CFormSelect
                    aria-label="Default select example"
                    onChange={handleAddLimit}
                    options={[
                      'Select Limit ',
                      { label: '10', value: '10' },
                      { label: '50', value: '50' },
                      { label: '100', value: '100' },
                      { label: '150', value: '150' },
                      { label: '200', value: '200' },
                      { label: '500', value: '500' },
                      { label: 'All', value: 'All' },
                    ]}
                  />
                </CCol>

                <CCol xs="auto">
                  <CFormSelect
                    aria-label="Default select example"
                    onChange={handleBatchName}
                    options={[
                      { label: "Select Batch", value: "" },
                      ...allBatches.map(batch => ({ label: batch.batch_name, value: batch.id }))
                    ]}
                  />
                </CCol>


                <CCol xs="auto">
                  <CButton
                    className="d-flex align-items-center"
                    onClick={addToBatchBtn}
                  >
                    Update Candidates
                  </CButton>
                </CCol>

              </CRow>

            </CRow>



            {tableData && tableData.length > 0 ? (
              <>
                <CTable responsive striped>
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell>
                        <CFormCheck
                          id="checkbox-select-all"
                          onChange={handleSelectAll}
                          checked={!!selectedRows[currentPage]}
                        />
                      </CTableHeaderCell>
                      {/* <CTableHeaderCell>#</CTableHeaderCell> */}
                      <CTableHeaderCell> Email_Id</CTableHeaderCell>
                      <CTableHeaderCell>First_Name</CTableHeaderCell>
                      <CTableHeaderCell>Middle_Name</CTableHeaderCell>
                      <CTableHeaderCell>Last_Name</CTableHeaderCell>
                      <CTableHeaderCell>sub_category_type</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {tableData.map((item, index) => (
                      <CTableRow key={item.id} className={style.tableRow}>
                        <CTableDataCell>
                          <CFormCheck
                            id={`checkbox-${item.id}`}
                            checked={!!CheckboxCandidate[item.id]}
                            onChange={() => handleRowSelect(item.id)}
                          />
                        </CTableDataCell>
                        {/* <CTableDataCell>{(currentPage - 1) * itemsPerPage + index + 1}</CTableDataCell> */}
                        <CTableDataCell>{item.email_id}</CTableDataCell>
                        <CTableDataCell>{item.first_name}</CTableDataCell>
                        <CTableDataCell>{item.middle_name}</CTableDataCell>
                        <CTableDataCell>{item.last_name}</CTableDataCell>
                        <CTableDataCell>{item.sub_category_type}</CTableDataCell>
                      </CTableRow>
                    ))}
                  </CTableBody>
                </CTable>

                <Pagination
                  totalRecords={totalRecords}
                  pageLimit={Number(params.limit)}
                  currentPage={currentPage}
                  pageNeighbours={1}
                  setPage={setPage}
                />

              </>
            ) : (
              <CCard className="mt-3">
                <CCardBody>
                  <h5 className="text-center">No Data available at this time</h5>
                </CCardBody>
              </CCard>
            )}
          </CCardBody>
        </CCard>
      </CContainer>
    </>
  );
};

export default index;




